import { RootState } from 'redux/schemas';

const getOrgUserDetails = (state: RootState, userId: number) => state.models.orgUsers[userId];

export default getOrgUserDetails;
